import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";

export default function CitiesChange() {
  const { t } = useLang();
  return (
    <section
      id="change"
      data-testid="section-change"
      className="relative bg-white text-[#1F2328] py-40 md:py-56"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-14">
        <div className="flex items-center gap-3 text-[11px] tracking-[0.35em] uppercase text-[#1F2328]/50 mb-12">
          <span className="h-px w-8 bg-[#B18B5E]" />
          {t.change.kicker}
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
          className="font-display font-light tracking-[-0.03em] leading-[1.02] max-w-[1200px]"
          style={{ fontSize: "clamp(2.5rem, 6vw, 5.5rem)" }}
        >
          <span className="block">{t.change.h1}</span>
          <span className="block text-[#1F2328]/35">{t.change.h2}</span>
        </motion.h2>

        <div className="mt-14 grid lg:grid-cols-12 gap-10">
          <motion.p
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.15 }}
            className="lg:col-span-7 text-[#1F2328]/70 text-lg md:text-xl leading-[1.55]"
          >
            {t.change.body}
          </motion.p>
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.25 }}
            className="lg:col-span-4 lg:col-start-9 border-l border-[#1F2328]/15 pl-6"
          >
            <p className="text-[#1F2328]/50 text-[15px] leading-relaxed">{t.change.quote}</p>
            <p className="mt-2 font-display text-[#1F2328] text-xl">{t.change.quoteBold}</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
